// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-module__homeContainer__RCSQy {
    min-height: 100vh;
    display: grid;
    grid-template-rows: 2fr min-content 1fr 1fr;
}

.home-module__intro__J6udU {
    border-top: 1px solid var(--color-border);
    border-bottom: 1px solid var(--color-border);
    grid-row: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.home-module__intro__J6udU>.home-module__name__xDKrK {
    font-size: 6rem;
    text-transform: uppercase;
}

.home-module__name__xDKrK {
    display: flex;
}

.home-module__name__xDKrK>div:first-child {
    color: var(--color-green);
}

.home-module__name__xDKrK>div:last-child {
    color: var(--color-cyan);
}

.home-module__intro__J6udU>div:nth-child(3) {
    padding: 1rem 4rem;
    display: flex;
    flex-direction: column;
}

.home-module__intro__J6udU>div:nth-child(2) {
    color: var(--color-green-muted);
    letter-spacing: 0.4rem;
}

.home-module__intro__J6udU>div:nth-child(3)>div:first-child {
    align-self: center;
    width: 120%;
    padding: 0.4rem;
    background-image: linear-gradient(to right, var(--color-green), var(--color-cyan));
    border-radius: 1rem;
    margin-bottom: 0.6rem;
}

.home-module__intro__J6udU>div:nth-child(3)>div:last-child {
    margin: 1rem 0;
    color: var(--color-green-muted);
}

.home-module__nameButtons__hkg2o {
    display: flex;
    gap: 1rem;
}

.home-module__nameButtons__hkg2o>button {
    padding: 1rem 1.4rem;
    background-color: var(--color-bg-primary);
    border: 1px solid grey;
    border-radius: 0.8rem;
    color: white;
}

.home-module__nameButtons__hkg2o>button:hover {
    background-color: var(--color-bg-secondary);
}


.home-module__served__y16oP {
    grid-row: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    justify-self: center;
    padding: 2rem;
    border-left: 1px solid var(--color-border);
    border-right: 1px solid var(--color-border);
    border-bottom: 1px solid var(--color-border);
    border-radius: 1rem;
    background-color: var(--color-bg-secondary);
}

.home-module__served__y16oP>div:last-child {
    color: var(--color-cyan);
    font-size: 3rem;
}


.home-module__title__IL4bN {
    text-transform: uppercase;
    margin: 2rem 0 2rem 4rem;
    letter-spacing: 0.4rem;
    color: var(--color-green-muted);
    font-size: 1.2rem;
}

.home-module__served__y16oP>.home-module__title__IL4bN {
    margin: 0;
}

.home-module__specials__fyhgt {
    grid-row: 3;
    margin-top: 3rem;
}

.home-module__specials__fyhgt>div:last-child {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 33% 33% 33%;
    border: 1px solid var(--color-border);
    width: 80%;
    justify-self: center;
    border-radius: 1rem;
    background-color: var(--color-bg-secondary);
}

.home-module__homeDish__tlVlp>div:first-child {
    color: var(--color-cyan-dim);
    font-size: 1rem;
    letter-spacing: 0.2rem;
    margin-bottom: 1rem;
}

.home-module__homeDish__tlVlp>div:nth-child(2) {
    color: var(--color-green);
    margin-bottom: 1rem;
}

.home-module__homeDish__tlVlp>div:last-child {
    color: var(--color-cyan);
    margin-top: 1rem;
}

.home-module__homeDish__tlVlp,
.home-module__review__KeGZE {
    padding: 1rem;

}

.home-module__reviews__WA8zE {
    border-top: 1px solid var(--color-border);
    grid-row: 4;
    margin-top: 3rem;

}

.home-module__reviews__WA8zE>div:last-child {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 33% 33% 33%;
    width: 80%;
    justify-self: center;
    background-color: var(--color-bg-secondary);
    border-radius: 1rem;
}

.home-module__review__KeGZE {
    display: grid;
    grid-template: min-content 1fr / 1fr min-content;
}

.home-module__review__KeGZE>div:first-child {
    color: var(--color-green);
    margin-bottom: 1rem;
}

.home-module__review__KeGZE>div:nth-child(2) {
    color: var(--color-cyan-ghost);
    background-color: var(--color-cyan-rank-bg);
    padding: 0.2rem;
    align-self: center;
}

.home-module__review__KeGZE>div:last-child {
    grid-column: 1 / 3;
}

.home-module__reviews__WA8zE>div:last-child>div:nth-child(2),
.home-module__specials__fyhgt>div:last-child>div:nth-child(2) {
    border-left: 1px solid var(--color-border);
    border-right: 1px solid var(--color-border);
}`, "",{"version":3,"sources":["webpack://./src/pages/home/home.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,yCAAyC;IACzC,4CAA4C;IAC5C,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kFAAkF;IAClF,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,yCAAyC;IACzC,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,2CAA2C;AAC/C;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,aAAa;IACb,0CAA0C;IAC1C,2CAA2C;IAC3C,4CAA4C;IAC5C,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;;AAGA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qCAAqC;IACrC,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;;AAEjB;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,UAAU;IACV,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,0CAA0C;IAC1C,2CAA2C;AAC/C","sourcesContent":[".homeContainer {\n    min-height: 100vh;\n    display: grid;\n    grid-template-rows: 2fr min-content 1fr 1fr;\n}\n\n.intro {\n    border-top: 1px solid var(--color-border);\n    border-bottom: 1px solid var(--color-border);\n    grid-row: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.intro>.name {\n    font-size: 6rem;\n    text-transform: uppercase;\n}\n\n.name {\n    display: flex;\n}\n\n.name>div:first-child {\n    color: var(--color-green);\n}\n\n.name>div:last-child {\n    color: var(--color-cyan);\n}\n\n.intro>div:nth-child(3) {\n    padding: 1rem 4rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.intro>div:nth-child(2) {\n    color: var(--color-green-muted);\n    letter-spacing: 0.4rem;\n}\n\n.intro>div:nth-child(3)>div:first-child {\n    align-self: center;\n    width: 120%;\n    padding: 0.4rem;\n    background-image: linear-gradient(to right, var(--color-green), var(--color-cyan));\n    border-radius: 1rem;\n    margin-bottom: 0.6rem;\n}\n\n.intro>div:nth-child(3)>div:last-child {\n    margin: 1rem 0;\n    color: var(--color-green-muted);\n}\n\n.nameButtons {\n    display: flex;\n    gap: 1rem;\n}\n\n.nameButtons>button {\n    padding: 1rem 1.4rem;\n    background-color: var(--color-bg-primary);\n    border: 1px solid grey;\n    border-radius: 0.8rem;\n    color: white;\n}\n\n.nameButtons>button:hover {\n    background-color: var(--color-bg-secondary);\n}\n\n\n.served {\n    grid-row: 2;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 80%;\n    justify-self: center;\n    padding: 2rem;\n    border-left: 1px solid var(--color-border);\n    border-right: 1px solid var(--color-border);\n    border-bottom: 1px solid var(--color-border);\n    border-radius: 1rem;\n    background-color: var(--color-bg-secondary);\n}\n\n.served>div:last-child {\n    color: var(--color-cyan);\n    font-size: 3rem;\n}\n\n\n.title {\n    text-transform: uppercase;\n    margin: 2rem 0 2rem 4rem;\n    letter-spacing: 0.4rem;\n    color: var(--color-green-muted);\n    font-size: 1.2rem;\n}\n\n.served>.title {\n    margin: 0;\n}\n\n.specials {\n    grid-row: 3;\n    margin-top: 3rem;\n}\n\n.specials>div:last-child {\n    display: grid;\n    grid-auto-flow: column;\n    grid-template-columns: 33% 33% 33%;\n    border: 1px solid var(--color-border);\n    width: 80%;\n    justify-self: center;\n    border-radius: 1rem;\n    background-color: var(--color-bg-secondary);\n}\n\n.homeDish>div:first-child {\n    color: var(--color-cyan-dim);\n    font-size: 1rem;\n    letter-spacing: 0.2rem;\n    margin-bottom: 1rem;\n}\n\n.homeDish>div:nth-child(2) {\n    color: var(--color-green);\n    margin-bottom: 1rem;\n}\n\n.homeDish>div:last-child {\n    color: var(--color-cyan);\n    margin-top: 1rem;\n}\n\n.homeDish,\n.review {\n    padding: 1rem;\n\n}\n\n.reviews {\n    border-top: 1px solid var(--color-border);\n    grid-row: 4;\n    margin-top: 3rem;\n\n}\n\n.reviews>div:last-child {\n    display: grid;\n    grid-auto-flow: column;\n    grid-template-columns: 33% 33% 33%;\n    width: 80%;\n    justify-self: center;\n    background-color: var(--color-bg-secondary);\n    border-radius: 1rem;\n}\n\n.review {\n    display: grid;\n    grid-template: min-content 1fr / 1fr min-content;\n}\n\n.review>div:first-child {\n    color: var(--color-green);\n    margin-bottom: 1rem;\n}\n\n.review>div:nth-child(2) {\n    color: var(--color-cyan-ghost);\n    background-color: var(--color-cyan-rank-bg);\n    padding: 0.2rem;\n    align-self: center;\n}\n\n.review>div:last-child {\n    grid-column: 1 / 3;\n}\n\n.reviews>div:last-child>div:nth-child(2),\n.specials>div:last-child>div:nth-child(2) {\n    border-left: 1px solid var(--color-border);\n    border-right: 1px solid var(--color-border);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeContainer": `home-module__homeContainer__RCSQy`,
	"intro": `home-module__intro__J6udU`,
	"name": `home-module__name__xDKrK`,
	"nameButtons": `home-module__nameButtons__hkg2o`,
	"served": `home-module__served__y16oP`,
	"title": `home-module__title__IL4bN`,
	"specials": `home-module__specials__fyhgt`,
	"homeDish": `home-module__homeDish__tlVlp`,
	"review": `home-module__review__KeGZE`,
	"reviews": `home-module__reviews__WA8zE`
};
export default ___CSS_LOADER_EXPORT___;
